<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-22 13:28:52
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-28 09:03:22
 * @Description: 结算调整
 * @FilePath: \ICPSxin\src\views\platform\ICPS\GHnumber\components\settleMentAdjust.vue
-->
<template>
    <div>
      <el-dialog v-dialogDrag :visible.sync="settleDialog" width="600px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">结算调整</span>
        <div style="margin-bottom: 10px;">
            <el-button class="bottom_one" @click="addAdjust()">添 加</el-button>
        </div>
        <div class="dialogOtherinfo">
          <el-table ref="table11Refs" height="400" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="listArr" tooltip-effect="dark" highlight-current-row>
            <el-table-column prop="createUserName" label="结算规则" width="auto" align="center">
                <template slot-scope="scope">
                  <div><el-link :underline="false"  type="success"  class="table_link"  @click="settleAdjust(scope.row,true)">查看</el-link></div>
                </template>
            </el-table-column>
            <el-table-column prop="startTime" label="生效时间" width="auto" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作" width="auto" align="center">
                <template slot-scope="scope">
                    <el-link :underline="false" type="warning" style="margin-right: 5px;" class="table_link" @click="settleAdjust(scope.row,false)">
                    修改
                  </el-link>
                  <el-link :underline="false" type="danger" class="table_link" @click="deleAdjust(scope.row.id)">
                    删除
                  </el-link>
                </template>
            </el-table-column>
          </el-table>
          <div class="card_bottom">
            <div class="card_bottom_left">
              <div class="top_page_totle">总共{{ modifyPage.total }}条</div>
              <el-pagination :current-page.sync="modifyPage.page" :page-size="modifyPage.pageSize" layout="prev, pager, next, jumper" :total="modifyPage.total" @current-change="settleMentAdjust()"></el-pagination>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="settleMentAdjust()">刷新</el-button>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="settleDialog = false">关 闭</el-button>
        </span>
      </el-dialog>
      <el-dialog v-dialogDrag :visible.sync="addSettlement" width="600px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">结算调整</span>
        <div>
            <el-form  ref="reffromDate"  :inline="true" :model="formDate" label-width="110px">
                <el-form-item prop="startTime" :rules="[{ required: true, message: '请选择生效日期', trigger: 'change' }]">
                  <span slot="label">生效日期</span>
                  <el-date-picker v-model="formDate.startTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px" :disabled="isEnable"></el-date-picker>
                </el-form-item>
                <el-row>
                <el-col :span="24">
                  <div>
                    <el-form-item class="zq">
                      <span slot="label">结算周期</span>
                      <el-select v-model="formDate.settlementCycleMouth" placeholder="请选择" style="width: 100px;margin-right: 10px;" :disabled="isEnable">
                        <el-option label="每月" value="1"></el-option>
                        <el-option label="每3月" value="2"></el-option>
                        <el-option label="每6月" value="3"></el-option>
                        <el-option label="每12月" value="4"></el-option>
                      </el-select>
                      <span>结算一次，结算日为</span>
                      <el-input-number v-model="formDate.settlementDay" style="width: 50px !important; margin: 0 10px" :max="31" :disabled="isEnable" :controls="false"></el-input-number>
                      <span>号</span>
                    </el-form-item>
                    <el-form-item prop="paymentMethod" :rules="[{ required: true, message: '请选择付款方式', trigger: 'change' }]">
                      <span slot="label">付款方式</span>
                      <el-select v-model="formDate.paymentMethod" style="width: 340px" placeholder="请选择" :disabled="isEnable">
                        <el-option label="账龄" value="1"></el-option>
                        <!-- <el-option label="比例" :value="2"></el-option> -->
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                </el-row>
                <el-form-item  class="zq" label-width="180px">
                  <span slot="label">进度支付时段（账龄）</span>
                  <el-input-number v-model="formDate.progressPaymentPeriod" style="width: 50px !important;margin-right: 10px" :disabled="isEnable" :controls="false"></el-input-number>
                  <el-select v-model="formDate.progressPaymentPeriodType" placeholder="请选择" :disabled="isEnable">
                    <el-option label="月" :value="1"></el-option>
                    <el-option label="季度" :value="2"></el-option>
                    <el-option label="年" :value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  class="zq">
                  <span slot="label">支付比例</span>
                  <el-input-number v-model="formDate.paymentRatio" style="width: 50px !important;margin-right: 10px" :disabled="isEnable" :controls="false"></el-input-number>
                  <span>%</span>
                </el-form-item>
                <el-form-item  class="zq">
                  <span slot="label">尾款支付</span>
                  <el-select v-model="formDate.balancePayment" :disabled="isEnable" placeholder="请选择" >
                    <el-option label="总结算后" :value="1"></el-option>
                    <el-option label="合同有效期内" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  class="zq" label-width="180px">
                  <span slot="label">尾款支付时段<span v-if="formDate.balancePayment == 2">（账龄）</span> </span>
                  <el-input-number v-model="formDate.balancePaymentPeriod" :disabled="isEnable"  style="width: 50px !important;margin-right: 10px" :controls="false"></el-input-number>
                  <el-select v-model="formDate.balanceUnit" :disabled="isEnable" placeholder="请选择" >
                    <el-option label="月" :value="1"></el-option>
                    <el-option label="季度" :value="2"></el-option>
                    <el-option label="年" :value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <span slot="label">结算说明</span>
                  <el-input v-model="formDate.settlementInstructions" style="width:400px" type="textarea" placeholder="请输入" clearable
                    :rows="4" resize="none" :disabled="isEnable"  maxlength="500" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="refuseAdjust()">取消</el-button>
          <el-button class="bottom_one" :disabled="isEnable" @click="saveAdjust()">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import { settlementQueryPage,saveOrUpdate,deleteOne } from "@/api/GHnumber/settlementAdjust";
  export default {
    data() {
      return {
        settleDialog: false,
        adjustParma:{},
        addSettlement: false,
        isEnable: false,
        listArr: [],
        formDate:{
            startTime:"",
            contractId:"",
            settlementCycleMouth:"",
            settlementDay:"",
            paymentMethod:"",
            paymentMethodld:"",
            balancePayment:"",
            balancePaymentPeriod:"",
            balanceUnit:"",
            paymentRatio:"",
            progressPaymentPeriod:"",
            progressPaymentPeriodType:"",
            settlementInstructions:"",
            settlementAdjustmentId:"",
        },
        modifyPage: {
          page: 1,
          pageSize: 10,
          total: 0,
          contractId: '',
        },
      };
    },
    methods: {
      settleMentAdjust(val) {
        if (val) {
          this.adjustParma = val
          this.modifyPage.contractId = val.id
        }
        this.settleDialog = true
        this.getSettAdjust();
      },
      addAdjust(){
        setTimeout(() => {
        this.$refs.reffromDate.clearValidate();
      }, 10)
        this.addSettlement = true
        this.isEnable = false
      },
      getSettAdjust(){
        settlementQueryPage(this.modifyPage).then((res) => {
          this.listArr = res.data.data
          this.modifyPage.total = res.data.totalRows
        })
      },
      settleAdjust(row,status){
        this.addSettlement = true
        this.isEnable = status
        this.formDate = row
      },
      deleAdjust(id){
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'bottom_all_two',
          confirmButtonClass: 'bottom_all',
          type: 'warning'
        }).then(() => {
          deleteOne({id:id}).then(res => {
            if(res.code == 1001) {
              this.$message.success('删除成功!')
              this.getSettAdjust()
            }
          })
        })
      },
      saveAdjust(){
        let _this = this;
        _this.formDate.contractId = _this.adjustParma.id
        _this.$refs.reffromDate.validate(valid => {
        if (valid) {
            saveOrUpdate(this.formDate).then(res => {
            if (res.code == 1001) {
              this.$message.success("操作成功");
              this.refuseAdjust();
              this.getSettAdjust();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      },
      refuseAdjust(){
        setTimeout(() => {
        this.$refs.reffromDate.clearValidate();
      }, 10)
        this.formDate={
          contractId:this.adjustParma.contractId,
          startTime:"",
          settlementCycleMouth:"",
          settlementDay:"",
          paymentMethod:"",
          paymentMethodld:"",
          balancePayment:"",
          balancePaymentPeriod:"",
          balanceUnit:"",
          paymentRatio:"",
          progressPaymentPeriod:"",
          progressPaymentPeriodType:"",
          settlementInstructions:"",
          settlementAdjustmentId:"",
          id:""
        },
        this.addSettlement = false 
      }
    }
  };
  </script>